import React, { useState, useRef, useEffect } from "react";

const CF_BASE = "https://d3duw5o0obopn7.cloudfront.net";

export default function HeroBackgroundVideo({ video, bgColor = "#131212" }) {
  const videoRef = useRef(null);
  const [videoReady, setVideoReady] = useState(false);
  const [videoEnded, setVideoEnded] = useState(false);
  const [useContain, setUseContain] = useState(false);

 const checkFit = () => {
  const vid = videoRef.current;
  if (!vid || !vid.videoWidth || !vid.videoHeight) return;

  const videoAspect = vid.videoWidth / vid.videoHeight;
  const viewportAspect = window.innerWidth / window.innerHeight;

  // If the viewport is narrower (relative to height) than the video,
  // 'cover' would crop the sides — switch to 'contain'.
  setUseContain(viewportAspect < videoAspect);
};

  useEffect(() => {
    window.addEventListener('resize', checkFit);
    return () => window.removeEventListener('resize', checkFit);
  }, []);

  useEffect(() => {
    if (videoRef.current && videoRef.current.readyState >= 3) {
      setVideoReady(true);
      checkFit();
    }
  }, [video]);

  return (
    <>
    <div
  style={{
    position: 'fixed',
    inset: 0,
    backgroundColor: videoEnded ? 'transparent' : 'black',
    transition: videoEnded ? 'background-color 0.6s ease' : 'none',
    zIndex: -2,
  }}
/>
      <video
        ref={videoRef}
        src={`${CF_BASE}/${video}`}
        autoPlay
        muted
        playsInline
        webkit-playsinline="true"
        preload="auto"
        onLoadedMetadata={checkFit}
        onCanPlay={() => { setVideoReady(true); checkFit(); }}
        onEnded={() => setVideoEnded(true)}
    style={{
  position: 'fixed',
  inset: 0,
  width: '100%',
  height: '100vh', // fallback for browsers without dvh support
  ...(CSS.supports('height', '100dvh') && { height: '100dvh' }),
  objectFit: useContain ? 'contain' : 'cover',
  objectPosition: 'center',
  zIndex: -1,
  opacity: videoEnded ? 0 : (videoReady ? 1 : 0),
  transition: videoEnded ? 'opacity 0.6s ease' : (videoReady ? 'none' : 'opacity 0.4s ease'),
  ...(useContain && {
    maskImage: `linear-gradient(to right, transparent, white 3%, white 90%, transparent), linear-gradient(to bottom, transparent, white 20%, white 80%, transparent)`,
    WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 95%, transparent), linear-gradient(to bottom, transparent, white 20%, white 80%, transparent)`,
    maskComposite: 'intersect',
    WebkitMaskComposite: 'source-in',
  }),
}}
      />
    </>
  );
}